import { useAtomValue } from "jotai";
import { hasNoLocationMembershipAtom } from "@/store/shipToAtoms";
import { NoLocationNote } from "@customer/_components/NoLocationNote";
import { MembershipTab } from "./_components/MembershipTab";

// Standalone customer route at /c/account/membership. Mirrors the page shell
// of AccountDashboard / AccountLocations (own bg + centered column + heading);
// MembershipTab renders the organization's single membership body.
export const MembershipPage = () => {
    const hasNoLocationMembership = useAtomValue(hasNoLocationMembershipAtom);

    return (
        <div className="bg-base-100 text-neutral min-h-[60vh]">
            <div className="max-w-3xl mx-auto px-4 py-6 md:py-8 flex flex-col gap-6">
                <h1 className="text-3xl font-bold text-neutral">Membership</h1>
                {/* #417: the tab below reports the ORGANISATION's subscription,
                    which is Active for a member seated on no location — so
                    without this line the page would say "Active" to someone
                    whose store is near-empty and never say why. */}
                {hasNoLocationMembership && <NoLocationNote />}
                <MembershipTab />
            </div>
        </div>
    );
};
